export default function noop(): void {}
